<template>
  <div>
    <!-- menu header -->
    <!--    <v-card elevation="0" fixed tile>-->
    <!--      <v-app-bar flat color="rgb(255, 255, 255)">-->
    <!--        <v-toolbar-title class="pl-0 header-area">-->
    <!--          <v-btn fab text x-small color="black" @click="goBack">-->
    <!--            <v-icon size="24">mdi-arrow-left</v-icon>-->
    <!--          </v-btn>-->
    <!--          <span class="align-self-center header-title">메뉴</span>-->
    <!--        </v-toolbar-title>-->
    <!--        <v-spacer />-->

    <!--        &lt;!&ndash; 설정버튼 &ndash;&gt;-->
    <!--        &lt;!&ndash;-->
    <!--        <v-btn @click="goSettingMenu" icon>-->
    <!--          <v-icon color="#363c43" size="24">mdi-cog-outline</v-icon>-->
    <!--        </v-btn>-->
    <!--        &ndash;&gt;-->
    <!--      </v-app-bar>-->
    <!--    </v-card>-->

    <!-- menu list -->
    <v-list nav>
      <menu-list-group
        class="all-menu-list"
        v-for="(item, index) in GET_MENU_LIST"
        v-bind:key="index"
        :categoryNm="item.categoryNm"
        :categoryCd="item.categoryCd"
        :menuList="item.menuList"
      />
    </v-list>
  </div>
</template>

<script>
/* 전체메뉴 */
import MenuListGroup from '@/components/menu/MenuListGroup.vue';
import { mapGetters } from 'vuex';
import routerConstants from '@/const/routerConstants';

export default {
  data: () => ({
    selectedItem: 1,
  }),

  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('MENU', ['GET_MENU_LIST']),
  },

  // watch: {
  //   GET_MENU_LIST() {
  //     // +. 공통 스피너 OFF
  //     this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
  //   },
  // },

  methods: {
    /* 설정메뉴 화면으로 이동 */
    goSettingMenu() {
      this.$router.push({ name: routerConstants.SettingMenu });
    },
    goBack() {
      this.$router.push({ name: routerConstants.Main });
      //this.$router.go(-1);
    },
  },

  mounted() {
    // 1. 접근시 state 초기화
    this.$store.commit('ELA/RESET_ELA_STATE');
    this.$store.commit('ELA/RESET_APPLICATION_STATE');
    this.$store.commit('SET_PER_DAY', 0);
    this.$store.commit('SET_FILE_SEQ', '');
  },

  components: {
    MenuListGroup,
  },
};
</script>
